import { ArrowRight, X } from "lucide-react";
import { Link } from "react-router-dom";

const TopBanner = ({ shouldDisplayBanner, setShowBanner }) => {
  return (
    shouldDisplayBanner && (
      <div className="w-full z-[60] bg-yellow-400 text-[rgb(0,73,69)] px-6 py-2 flex items-center justify-between shadow-md space-x-1">
        <div className="flex-1 text-center text-sm font-bold flex items-center justify-center gap-2 flex-wrap">
          <span>🚀 We are migrating our products.</span>
          <Link
            to="/migration-guide"
            className="underline inline-flex items-center gap-1 hover:opacity-80"
          >
            Learn more <ArrowRight size={14} />
          </Link>
        </div>
        <button
          onClick={() => setShowBanner(false)}
          className="hover:bg-black/10 rounded-full p-1 transition-colors"
        >
          <X size={18} />
        </button>
      </div>
    )
  );
};
export default TopBanner;
